import { LinkButton, PublicButton } from '@yes.technology/react-toolkit'
import { getPublicButtonRest, isPublicButton } from 'shared/utils'
import { PublicButtonPropsWithType } from 'site/Renderer/components/DataCards/DataCards.types'

export type FilteredObjectButtonProps = {
  href: string
  label: string
  target?: '_self' | '_blank'
  isDisabled: boolean
  buttonProps?: PublicButtonPropsWithType
  style?: React.CSSProperties
}

const FilteredObjectButton = ({
  href,
  label,
  target = '_blank',
  isDisabled,
  style,
  buttonProps
}: FilteredObjectButtonProps) => {
  const buttonHref = isDisabled ? '#' : href

  if (isPublicButton(buttonProps)) {
    return (
      <PublicButton
        href={buttonHref}
        target={target}
        {...getPublicButtonRest(buttonProps)}
        disabled={isDisabled}
        style={style}
      >
        {label}
      </PublicButton>
    )
  }

  return (
    <LinkButton
      variant='secondary'
      href={buttonHref}
      target={target}
      style={style}
      disabled={isDisabled}
    >
      {label}
    </LinkButton>
  )
}

export default FilteredObjectButton
